import logo from "@/assets/logo.png";

/**
 * The original Path & Pace logo, converted to a real RGBA image: the source
 * JPEG's luminance became the alpha channel, so the mark is genuinely
 * transparent rather than relying on mix-blend-mode to hide a black frame.
 *
 * That blend trick broke inside the header, where `backdrop-filter` creates a
 * stacking context and the blend no longer resolved against the page — leaving
 * a visible black square. This has no background to hide.
 */
export function Logo({ className, alt = "Path and Pace" }: { className?: string; alt?: string }) {
  return (
    <img src={logo} alt={alt} className={className} width={566} height={313} />
  );
}
